import React, { useMemo, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useMasterDataAddUserContext } from "../MasterDataUserUIContext";
import MasterDataUserDialogForm from "./MasterDataUserDialogForm";
import {
  createSuperAdminUser,
  updateSuperAdminUser
} from "../../../_redux/master-data-user/masterDataUserCrud";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../../_metronic/_helpers";
import * as actions from "../../../_redux/master-data-user/masterDataUserAction";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

export default function MasterDataUserDialog({ id, show, onHide }) {
  const MasterDataUserUIContext = useMasterDataAddUserContext();
  const MasterDataUserUIProps = useMemo(() => {
    return {
      queryParams: MasterDataUserUIContext.queryParams,
      initUser: MasterDataUserUIContext.initUser
    };
  }, [MasterDataUserUIContext]);

  const dispatch = useDispatch();

  const { actionsLoading, masterDataForEdit, error } = useSelector(
    state => state.superAdminMasterDataUser,
    shallowEqual
  );

  const { user } = useSelector(state => state.auth, shallowEqual);

  if (error) {
    toast.error(error, toastOption);
  }

  useEffect(() => {
    // server call for getting User by id
    dispatch(actions.fetchUserBySuperAdmin(id));
  }, [id, dispatch]);

  const saveUser = async user => {
    if (!id) {
      createSuperAdminUser(user)
        .then(response => {
          toast.success(response.data.message, toastOption);
          onHide();
          dispatch(actions.reloadFetchUser());
        })
        .catch(error => {
          toast.error(error.response.data.message, toastOption);
        });
    } else {
      updateSuperAdminUser(id, user)
        .then(response => {
          toast.success(response.data.message, toastOption);
          onHide();
          dispatch(actions.reloadFetchUser());
        })
        .catch(error => {
          toast.error(error.response.data.message, toastOption);
        });
    }
  };

  function getInitValue() {
    if (masterDataForEdit) {
      const data = {
        ...masterDataForEdit
      };
      return data;
    }

    const data = { ...MasterDataUserUIProps.initUser };
    if (user.regional_uuid) {
      data.regional_uuid = user.regional_uuid;
      data.regional_name = user.regional.name;
    }
    return data;
  }

  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          onHide();
          dispatch(actions.reloadFetchUser());
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <h4>{id ? `Update User` : "Tambah User"}</h4>
        </Modal.Header>
        <Modal.Body>
          <MasterDataUserDialogForm
            onSubmit={saveUser}
            actionsLoading={actionsLoading}
            defaultValues={getInitValue()}
            onHide={() => {
              onHide();
            }}
            user={user}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
